import { render, staticRenderFns } from "./ModifyQuizGrades.vue?vue&type=template&id=46b80722&scoped=true&"
import script from "./ModifyQuizGrades.vue?vue&type=script&lang=js&"
export * from "./ModifyQuizGrades.vue?vue&type=script&lang=js&"
import style0 from "./ModifyQuizGrades.vue?vue&type=style&index=0&id=46b80722&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b80722",
  null
  
)

export default component.exports